import { useMemo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import AdminLayout from '../../components/admin/AdminLayout';
import ApprenantParrainagePanel from '../../components/apprenant/ApprenantParrainagePanel';
import PortalWalletPanel from '../../components/shared/PortalWalletPanel';
import PortalNotificationsPanel from '../../components/shared/PortalNotificationsPanel';
import PortalHelpPanel from '../../components/shared/PortalHelpPanel';
import { PORTAL_HELP_PATHS } from '../../config/portalHelpContent';
import type { AdminBreadcrumbSegment } from '../../components/admin/AdminBreadcrumb';
import type { AdminNavItem } from '../../types/admin';

const NAV: AdminNavItem[] = [
  { id: 'parrainage', label: 'Parrainage', icon: 'groups', path: '/partenaire/parrainage' },
  { id: 'wallet', label: 'Portefeuille', icon: 'account_balance_wallet', path: '/partenaire/wallet' },
];

type PartenaireUser = {
  telephone?: string;
  profil?: { prenom?: string; nom?: string; photoUrl?: string | null };
};

type Props = {
  user: PartenaireUser;
  onLogout: () => void;
};

export default function PartenaireAcademiaPage({ user, onLogout }: Props) {
  const location = useLocation();
  const fullName = [user.profil?.prenom, user.profil?.nom].filter(Boolean).join(' ');

  const breadcrumb: AdminBreadcrumbSegment[] = useMemo(() => {
    if (location.pathname.startsWith('/partenaire/notifications')) {
      return [{ label: 'Espace partenaire' }, { label: 'Notifications' }];
    }
    if (location.pathname.startsWith('/partenaire/aide')) {
      return [{ label: 'Espace partenaire' }, { label: 'Centre d’aide' }];
    }
    const section = location.pathname.startsWith('/partenaire/wallet') ? 'Mon portefeuille' : 'Parrainage';
    return [{ label: 'Espace partenaire' }, { label: section }];
  }, [location.pathname]);

  return (
    <AdminLayout
      navigation={NAV}
      user={{
        name: fullName || user.telephone || 'Partenaire',
        subtitle: 'Partenaire institutionnel',
        photoUrl: user.profil?.photoUrl ?? null,
        prenom: user.profil?.prenom,
        nom: user.profil?.nom,
      }}
      breadcrumb={breadcrumb}
      onLogout={onLogout}
      searchQuery=""
      onSearchChange={() => {}}
      brandAlt="JCONSULT MY Academia"
      helpPath={PORTAL_HELP_PATHS.partenaire}
    >
      <Routes>
        <Route path="/" element={<Navigate to="/partenaire/parrainage" replace />} />
        <Route path="/parrainage" element={<ApprenantParrainagePanel portal="formateur" user={user} />} />
        <Route
          path="/wallet"
          element={<PortalWalletPanel portal="partenaire" parrainagePath="/partenaire/parrainage" />}
        />
        <Route path="/notifications" element={<PortalNotificationsPanel portal="partenaire" />} />
        <Route path="/aide" element={<PortalHelpPanel portal="partenaire" />} />
        <Route path="*" element={<Navigate to="/partenaire/parrainage" replace />} />
      </Routes>
    </AdminLayout>
  );
}
